/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  /**
   * @param term {string} the `proofPurpose` term, as defined in the
   *    SECURITY_CONTEXT_URL `@context` or a URI if not defined in such.
   * @param [date] {string or Date or integer} the expected date for
   *   the creation of the proof.
   * @param [maxTimestampDelta] {integer} a maximum number of seconds that
   *   the date on the signature can deviate from, defaults to `Infinity`.
   */
  function ProofPurpose() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        term = _ref.term,
        date = _ref.date,
        _ref$maxTimestampDelt = _ref.maxTimestampDelta,
        maxTimestampDelta = _ref$maxTimestampDelt === void 0 ? Infinity : _ref$maxTimestampDelt;

    _classCallCheck(this, ProofPurpose);

    if (term === undefined) {
      throw new Error('"term" is required.');
    }

    if (maxTimestampDelta !== undefined && typeof maxTimestampDelta !== 'number') {
      throw new TypeError('"maxTimestampDelta" must be a number.');
    }

    this.term = term;

    if (date !== undefined) {
      this.date = new Date(date);

      if (isNaN(this.date)) {
        throw TypeError("\"date\" \"".concat(date, "\" is not a valid date."));
      }
    }

    this.maxTimestampDelta = maxTimestampDelta;
  }
  /**
   * Called to validate the purpose of a proof. This method is called during
   * proof verification, after the proof value has been checked against the
   * given verification method (e.g. in the case of a digital signature, the
   * signature has been cryptographically verified against the public key).
   *
   * @param proof {object} the proof, in the `constants.SECURITY_CONTEXT_URL`,
   *   with the matching purpose to validate.
   *
   * @return {Promise<object>} resolves to an object with `valid` and `error`.
   */


  _createClass(ProofPurpose, [{
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(proof, _ref2) {
        var document, suite, verificationMethod, documentLoader, expansionMap, expected, delta, created;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document = _ref2.document, suite = _ref2.suite, verificationMethod = _ref2.verificationMethod, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap;
                _context.prev = 1;

                if (!(this.maxTimestampDelta !== Infinity)) {
                  _context.next = 8;
                  break;
                }

                expected = (this.date || new Date()).getTime();
                delta = this.maxTimestampDelta * 1000;
                created = new Date(proof.created).getTime(); // comparing this way handles NaN case where `created` is invalid

                if (created >= expected - delta && created <= expected + delta) {
                  _context.next = 8;
                  break;
                }

                throw new Error('The proof\'s created timestamp is out of range.');

              case 8:
                return _context.abrupt("return", {
                  valid: true
                });

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  valid: false,
                  error: _context.t0
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function validate(_x, _x2) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     * Called to update a proof when it is being created, adding any properties
     * specific to this purpose. This method is called prior to the proof
     * value being generated such that any properties added may be, for example,
     * included in a digital signature value.
     *
     * @param proof {object} the proof, in the `constants.SECURITY_CONTEXT_URL`
     *   to update.
     *
     * @return {Promise<object>} resolves to the proof instance (in the
     *   `constants.SECURITY_CONTEXT_URL`.
     */

  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(proof, _ref3) {
        var document, suite, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                document = _ref3.document, suite = _ref3.suite, documentLoader = _ref3.documentLoader, expansionMap = _ref3.expansionMap;
                proof.proofPurpose = this.term;
                return _context2.abrupt("return", proof);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x3, _x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
    /**
     * Determines if the given proof has a purpose that matches this instance,
     * i.e. this ProofPurpose instance should be used to validate the given
     * proof.
     *
     * @param proof {object} the proof to check.
     *
     * @return {Promise<boolean>} `true` if there's a match, `false` if not.
     */

  }, {
    key: "match",
    value: function () {
      var _match = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(proof, _ref4) {
        var document, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                document = _ref4.document, documentLoader = _ref4.documentLoader, expansionMap = _ref4.expansionMap;
                return _context3.abrupt("return", proof.proofPurpose === this.term);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function match(_x5, _x6) {
        return _match.apply(this, arguments);
      }

      return match;
    }()
  }]);

  return ProofPurpose;
}();